import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';

export const REVIEW_LAST_PAID_INVOICE_SCHEMA = Object.freeze({
  NUMBER: '',
  ID: '',
  PAID_DATE: '',
});
const RECORD = generateSchema(REVIEW_LAST_PAID_INVOICE_SCHEMA);
const KEYS: any = generateKeys(REVIEW_LAST_PAID_INVOICE_SCHEMA);

export class ReviewLastPaidInvoice extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get number(): string {
    return this.get(KEYS.NUMBER);
  }

  get id(): string {
    return this.get(KEYS.ID);
  }

  get paidDate(): string {
    return this.get(KEYS.PAID_DATE);
  }
}
